import { isAdapterPresent } from '../adapters/AdapterManager';

export default function doesItemExist(hostItemIndex: string): boolean {
    return isAdapterPresent(hostItemIndex);
}
